<template>
  <div class="c-period-navigator">
    <div class="c-period-navigator__period">
      {{ period_label }}
    </div>

    <v-row align="center">
      <v-col class="text-center">
        <v-btn
          outlined
          class="c-period-navigator__navigation"
          height="100"
          width="40"
          min-width="0"
          @click="previous"
        >
          <v-icon>fast_rewind</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="10">
        <slot>
        </slot>
      </v-col>

      <v-col class="text-center">
        <v-btn
          outlined
          class="c-period-navigator__navigation"
          height="100"
          width="40"
          min-width="0"
          @click="next"
        >
          <v-icon>fast_forward</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { STATS_INC_PERIOD, STATS_DEC_PERIOD } from '@/store/actions/stats';

export default {
  name: 'PeriodNavigator',

  computed: {
    ...mapState({
      period_label: state => state.stats.period_label
    })
  },

  methods: {
    ...mapActions({
      previous: STATS_DEC_PERIOD,
      next: STATS_INC_PERIOD
    })
  }
};
</script>

<style lang="scss" scoped>
  .c-period-navigator {
    &__period {
      text-align: center;
    }
  }
</style>
